import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import { Grid, Typography, Button } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import errorIllustrationDark from '@rbx/foundation-images/pictograms/alert_dark.svg';
import errorIllustrationLight from '@rbx/foundation-images/pictograms/alert_light.svg';
import usePageNotFoundStyles from '@modules/miscellaneous/common/components/error/PageNotFound.style';
import ThemedImage from '@modules/miscellaneous/common/components/ThemedImage';

const PageNotFound = () => {
  const { translate } = useTranslation();
  const {
    classes: { description, background, button },
  } = usePageNotFoundStyles();
  const router = useRouter();

  const handleReturnButtonClick = useCallback(() => {
    router.push('/');
  }, [router]);

  return (
    <Grid container classes={{ root: background }} direction='column' alignItems='center'>
      <Grid container item justifyContent='center'>
        <ThemedImage
          lightSrc={errorIllustrationLight.src}
          darkSrc={errorIllustrationDark.src}
          alt='Error Illustration'
        />
        {/* <Image src={errorIllustrationLight} alt='Error Illustration' /> */}
      </Grid>
      <Grid container item flexDirection='column' alignItems='center'>
        <Typography variant='h4' align='center'>
          {translate('Message.404')}
        </Typography>

        <Typography classes={{ root: description }} color='secondary' align='center'>
          {translate('Message.404Description')}
        </Typography>

        <Button
          classes={{ root: button }}
          color='primary'
          variant='contained'
          onClick={handleReturnButtonClick}>
          {translate('Action.ReturnToProduct1', { productLink: translate('Label.Documentation') })}
        </Button>
      </Grid>
    </Grid>
  );
};

export default PageNotFound;
